// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

if (!customElements.get('cta-features')) {
  customElements.define(
    'cta-features',
    class CtaCarousel extends window.BAO.CustomElement() {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.controlPrevEl = this.querySelector(
          '[data-el="cta-features.controlprevious"]',
        )
        this.controlNextEl = this.querySelector(
          '[data-el="cta-features.controlnext"]',
        )

        this.carousel = this.initialiseCarousel()

        this.controlPrevEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
        this.controlNextEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
      }

      initialiseCarousel () {
        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'free-snap',
          slidesPerView: 1.2,
          slides: '.car-Carousel_Slide',
          spacing: 15,
          breakpoints: {
            '(min-width: 768px)': {
              mode: 'snap',
              controls: this.els.slide.elements.length > 2,
              slidesPerView: 2.2,
              spacing: 20,
            },
            '(min-width: 901px)': {
              mode: 'snap',
              controls: this.els.slide.elements.length > 4,
              slidesPerView: 4,
              spacing: 20,
            },
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })

            const maxClicks =
              instance.details().size - instance.details().slidesPerView

            if (this.controlPrevEl) {
              instance.details().relativeSlide === 0
                ? (this.controlPrevEl.disabled = true)
                : (this.controlPrevEl.disabled = false)
            }

            if (this.controlNextEl) {
              instance.details().relativeSlide >= maxClicks
                ? (this.controlNextEl.disabled = true)
                : (this.controlNextEl.disabled = false)
            }
          },
        })
      }

      onNavClick (event) {
        if (event.currentTarget.dataset.direction === 'previous') {
          this.carousel.prev()
        } else {
          this.carousel.next()
        }
      }
    },
  )
}
